import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { IS_HEALTH_MONITORING_TAB_HIDDEN, IS_ALERTS_TAB_HIDDEN, IS_SITE_MANAGEMENT_TAB_HIDDEN, IS_CAMERAS_TAB_HIDDEN, DASHBOARD_INTERVAL_TIMER, MULTI_TIME_ZONE } from '../../config'
import { ClosedAlertIcon, WFIcon, ErrorIcon, SystemHealth, AlertWhiteIcon, SiteWhiteIcon, CameraWhiteIcon } from '../../assets/images'

import { GetDashboardDetails, GetDashboardWorkflow, GetDeviceCount, GetMaxSeverityAlertTitle, GetSiteCount, GetSystemHealth, GetTodaysAlertCount, SystemHealthDevicesCountDash } from "../../services/dashboardService"
import { GetEventTemplateList, DeleteEventTemplate } from '../../services/configurationServices'
import { getAlertList } from "../../services/alertAuthService";
import { LogoutDotNet } from '../../services/userAuthServices'

import DashboardWidget from './DashboardWidget'
import DashboardMiniWidget from './DashboardMiniWidget'
import { CheckForPrivilege } from '../Profile/PrivilegeExtension'
import { AllDateFormat, ConvertDate, logOutMain, multiTimeZoneHelper } from '../../utils/utils'
import { mixpanel } from '../../utils/MixPanelUtil'
import AlertTable from './AlertTable'
import LocationList from './LocationList'
import EventTemplateList from './EventTemplateList'

import Swal from 'sweetalert2'
import InfiniteScroll from "react-infinite-scroll-component"
import Skeleton from "react-loading-skeleton";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, LineElement, LinearScale, PointElement, TimeScale, ScatterController } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import HealthIntegratedChart from '../HealthMonitoring/HealthIntegratedChart'
import SampleChart from '../HealthMonitoring/SampleChart'
import { addMinutes, subMinutes, differenceInMinutes } from 'date-fns'
import { ALLALERTS, CAMERAS } from '../../navigation/CONSTANTS'
import HealthPercent from '../HealthMonitoring/HealthPercent'
import { AlertsModule } from '../../utils/ModuleConstants'

ChartJS.register(ArcElement, Tooltip, Legend, TimeScale, LineElement, LinearScale, PointElement, ScatterController);

export default function DashboardContainer(props) {
    let getMenusAccess = JSON.parse(localStorage.getItem('user'))
    let menusAccess = getMenusAccess?.MenuList
    let IS_DASHBOARD_TAB_HIDDEN = true    
    let IS_ALERTS_TAB_HIDDEN = true
    let IS_CAMERAS_TAB_HIDDEN = true
    let IS_HEALTH_MONITORING_TAB_HIDDEN = true
    let IS_PANELCONTROL_TAB_HIDDEN = true
    let IS_REPORTS_TAB_HIDDEN = true
    let IS_CUSTOM_REPORTS_TAB_HIDDEN = true
    let IS_CONFIGURATION_TAB_HIDDEN = true

    const checkViewOperation = (menuName) => {
        const menu = menusAccess.find((item) => item.Menuname === menuName);
        return menu ? menu.ViewOperation : false;
    };

    if(getMenusAccess != null && menusAccess != undefined){

         IS_DASHBOARD_TAB_HIDDEN = !checkViewOperation("Home Page");
         IS_ALERTS_TAB_HIDDEN = !checkViewOperation(AlertsModule);
         IS_CAMERAS_TAB_HIDDEN = !checkViewOperation("Cameras");
         IS_HEALTH_MONITORING_TAB_HIDDEN = !checkViewOperation("Health Monitoring");
         IS_PANELCONTROL_TAB_HIDDEN = !checkViewOperation("Panel Control");
         IS_REPORTS_TAB_HIDDEN = !checkViewOperation("Reports");
         IS_CUSTOM_REPORTS_TAB_HIDDEN = !checkViewOperation("Custom Reports");
         IS_CONFIGURATION_TAB_HIDDEN = !checkViewOperation("Configuration Tool");

        // IS_DASHBOARD_TAB_HIDDEN = !menusAccess[0]?.ViewOperation == true    
        // IS_ALERTS_TAB_HIDDEN = !menusAccess[1]?.ViewOperation == true
        // IS_CAMERAS_TAB_HIDDEN = !menusAccess[2]?.ViewOperation == true
        // IS_HEALTH_MONITORING_TAB_HIDDEN = !menusAccess[3]?.ViewOperation == true
        // IS_PANELCONTROL_TAB_HIDDEN = !menusAccess[4]?.ViewOperation == true
        // IS_REPORTS_TAB_HIDDEN = !menusAccess[5]?.ViewOperation == true
        // IS_CUSTOM_REPORTS_TAB_HIDDEN = !menusAccess[6]?.ViewOperation == true
        // IS_CONFIGURATION_TAB_HIDDEN = !menusAccess[7]?.ViewOperation == true
    }
    
    let history = useHistory()

    //useState Block Start
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [dashboardData, setDashboardData] = useState(null)
    const [eventTemplates, setEventTemplates] = useState(null)
    const [isSuperUser, setIsSuperUser] = useState(null);
    const [selectedSiteTab, setSelectedSiteTab] = useState('topThreeSites')
    const [systemHealthDevicesOfflineCount, setSystemHealthDevicesOfflineCount] = useState(0);
    const [systemHealthDevicesOnlineCount, setSystemHealthDevicesOnlineCount] = useState(0);
    const [onlinePercent, setOnlinePercent] = useState(0);
    const [darkPieGraph, setDarkPieGraph] = useState(props.isDarkTheme);
    const [loading, setLoading] = useState(false);
    const [dashboardLoading, setDashboardLoading] = useState(false);
    const [alert] = useState(CheckForPrivilege("ALERT"))
    const [camera] = useState(CheckForPrivilege("CAMERALIST_VIEW"))
    const [todaysAlertList, setTodaysAlertList] = useState([])
    const [resetDashRefresh, setReseDashRefresh] = useState("");
    const [nonIntegratedDevicesCount, setNonIntegratedDevicesCount] = useState(0);
    const [currentDT, setCurrentDT] = useState(null)
    const [deviceCount, setDeviceCount] = useState(0)
    const [siteCount,setSiteCount] = useState(0)
    const[todaysAlertCount,setTodaysAlertCount] = useState(0)
    const[siteLoading,setSiteLoading] = useState(false)
    const[deviceLoading,setDeviceLoading] = useState(false)
    const[todayAlertLoading,setTodayAlertLoading] = useState(false)
    const[count, setCount] = useState(0)
    const[closedAlertCount,setClosedAlertCount] = useState(0)
    const[maxSeverityTitle,setMaxSeverityTitle] = useState("")
    const[workflowDash,setWorkflowDash] = useState("")
    //useState Block Start

    // useEffect Block Start
    const getFirstDate = () => {
        let d;
        let loggedInUser = JSON.parse(localStorage.getItem('user'))
        if (MULTI_TIME_ZONE) {
          d = multiTimeZoneHelper(loggedInUser?.OffsetMinutes)
        } else {
          d = new Date();
        }
        return d;
      }
      
      const getSecondDate = () => {
        let e;
        let loggedInUser = JSON.parse(localStorage.getItem('user'))
        if (MULTI_TIME_ZONE) {
          e = multiTimeZoneHelper(loggedInUser?.OffsetMinutes)
        } else {
          e = new Date();
        }
        return e;
      }
    useEffect(()=>{
        let user = JSON.parse(localStorage.getItem('user'))
        getDeviceCount(user?.Id)
    },[])

    useEffect(()=>{
        let user = JSON.parse(localStorage.getItem('user'))
        getMaxSeverityTitle(user?.Id)
    },[])

    useEffect(()=>{
        getDashBoardWorkflow()
    },[])

    useEffect(()=>{
        let user = JSON.parse(localStorage.getItem('user'))
        getSiteCount(user?.Id)
    },[])

    useEffect(()=>{
        let user = JSON.parse(localStorage.getItem('user'))
        let start = getFirstDate();
        let end = getSecondDate();
        let startDate = ConvertDate(new Date(start.setHours(0, 0, 0, 0)));
        let endCurrDate = ConvertDate(end);
        getTodaysAlertCount(user?.Id,startDate,endCurrDate)
    },[])

    useEffect(() => {
        props.setSelectedTab('dashboard')
    }, [])


    useEffect(() => {
        let tempUser = JSON.parse(localStorage.getItem('user'))
        if (tempUser) {
            let check = tempUser?.UserRoleID == 1 || tempUser?.UserRoleID == 2 || tempUser?.roleId == 1 || tempUser?.roleId == 2;
            setIsSuperUser(check);
            setLoggedInUser(tempUser);

            //SystemHealthDevicesCount();
           SystemHealthCount()
        }
    }, [localStorage.getItem('user')]);

    useEffect(() => {
        let tempUser = JSON.parse(localStorage.getItem('user'))

        if (tempUser) {
        let start = getFirstDate();
        let end = getSecondDate();
        let startDate = ConvertDate(new Date(start.setHours(0, 0, 0, 0)));
        let endCurrDate = ConvertDate(end);
        getTodaysAlertCount(tempUser?.Id,startDate,endCurrDate);
            //GetUserDashboardDetails()
            getSiteCount(tempUser?.Id);
            getDeviceCount(tempUser?.Id);
            getMaxSeverityTitle(tempUser?.Id)
            getDashBoardWorkflow()
            // getEventTemplatesList()
            try {
                mixpanel.track("Clicks on Dashboard")
            } catch (error) {
                console.error(error)
            }
        }
    }, [loggedInUser])

    useEffect(() => {
        (async () => {
            if (props.todaysAlertList && props.todaysAlertList.length > 0) {
                setTodaysAlertList(props.todaysAlertList)
            }
        })();
    }, [props.todaysAlertList])

    useEffect(() => {
        let c = onlinePercent;
        setOnlinePercent(c)
        let d = props.isDarkTheme;
        setDarkPieGraph(d);
    }, [props]);

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem('user'))
        const interval = setInterval(async () => {
            //GetUserDashboardDetails();
            let start = getFirstDate();
        let end = getSecondDate();
        let startDate = ConvertDate(new Date(start.setHours(0, 0, 0, 0)));
        let endCurrDate = ConvertDate(end);
        getTodaysAlertCount(user?.Id,startDate,endCurrDate);

             getSiteCount(user?.Id);
             getDeviceCount(user?.Id);
             getMaxSeverityTitle(user?.Id)
             getDashBoardWorkflow()
             let refreshDate;
                    if(MULTI_TIME_ZONE){
                        let loggedInUser = JSON.parse(localStorage.getItem('user'))
                        let offSetMinutes = loggedInUser?.OffsetMinutes;
                        refreshDate = multiTimeZoneHelper(offSetMinutes)
                    }else{
                        refreshDate = new Date();
                    }
                    // let refreshDate = new Date();
                    setReseDashRefresh(AllDateFormat(refreshDate))
           // SystemHealthDevicesCount();
            SystemHealthCount();
        }, DASHBOARD_INTERVAL_TIMER);
        return () => {
            clearInterval(interval)
        }
    }, [])
    // useEffect Block End

    //Function Block Start
    const getMaxSeverityTitle = (userID) =>{
        let user = JSON.parse(localStorage.getItem('user'))
        GetMaxSeverityAlertTitle(user?.Id).then((resp)=>{
            if (resp.Status == "success"){
                if(resp.Data != null){
                    setMaxSeverityTitle(resp.Data[0].SeverityTitle)
                }
            }else {
                setMaxSeverityTitle("")
            }
        }).catch(err => console.log(err))
    }

    const getDashBoardWorkflow = (AlertDate) =>{
        GetDashboardWorkflow(AlertDate).then((resp)=>{
            if (resp.Status == "success"){
                if(resp.Data != null){
                    setWorkflowDash(resp.Data[0].WorkflowName)
                }
            }else {
                setWorkflowDash("")
            }
        }).catch(err => console.log(err))
    }

    const getDeviceCount = (userID) =>{
        let user = JSON.parse(localStorage.getItem('user'))
        setDeviceLoading(true)
        GetDeviceCount(user?.Id).then((resp)=>{
            if (resp.Status == "success"){
                if(resp.Data != null){
                    setDeviceCount(resp.Data[0].CameraCount)
                }
            }else {
                setDeviceCount(0)
            }
            setDeviceLoading(false)
        }).catch(err => console.log(err))
    }

    const getSiteCount = () =>{
        let user = JSON.parse(localStorage.getItem('user'))
        setSiteLoading(true)
        GetSiteCount(user?.Id).then((resp)=>{
            if (resp.Status == "success"){
                if(resp.Data != null){
                    setSiteCount(resp.Data[0].SiteCount)
                }
            }else {
                setSiteCount(0)
            }
            setSiteLoading(false)
        }).catch(err => console.log(err))
    }


    const getTodaysAlertCount = (userID,startDate,endCurrDate) =>{
        let user = JSON.parse(localStorage.getItem('user'))
        setTodayAlertLoading(true)
        GetTodaysAlertCount(user?.Id,startDate,endCurrDate).then((resp)=>{
            if (resp.Status == "success"){
                if(resp.Data != null){
                    if (resp.Data) {
                        const totalAlertCount = resp.Data.reduce((sum, item) => sum + (item.AlertCount || 0), 0);
                        setTodaysAlertCount(totalAlertCount);
                        let closedCount = resp.Data.find((item)=> item.AlertStatus == "Closed");
                        setClosedAlertCount(closedCount?.AlertCount || 0)

                        
                    } else {
                        setTodaysAlertCount(0);
                    }
                    //setTodaysAlertCount(resp.Data[0].AlertCount)
                }
            }else {
                setTodaysAlertCount(0)
            }
            setTodayAlertLoading(false)
        })
    }
    const SystemHealthCount = () => {
        setLoading(true);
        let user = JSON.parse(localStorage.getItem('user'))
        
        try{
            GetSystemHealth(user?.Id).then((resp) => {
                if (resp.Status == "success") {
                    if(resp.Data == null){
                        setLoading(false);
                        return  
                    }
                    let totalSystemHealthOffline = resp.Data.filter(item =>  item.DeviceStatus == "0")
                    setSystemHealthDevicesOfflineCount(totalSystemHealthOffline[0]?.StatusCount || 0)
                    let offlineCount = totalSystemHealthOffline[0]?.StatusCount || 0;
                    let totalSystemHealthOnline = resp.Data.filter(item => item.DeviceStatus == "1")
                    setSystemHealthDevicesOnlineCount(totalSystemHealthOnline[0]?.StatusCount || 0)
                    let onlineCount = totalSystemHealthOnline[0]?.StatusCount || 0
                    let total = parseInt(onlineCount) + parseInt(offlineCount)
                    let percent = (onlineCount / total) * 100;
                    if (isNaN(percent)) {
                        setOnlinePercent(0);
                    } else {
                        setOnlinePercent(percent.toFixed(0));
                    }

                    let c = count + 1;
                    setCount(c)

                    let nonIntegratedDevices = resp.Data.filter(item => item.DeviceStatus == "-1");
                    setNonIntegratedDevicesCount((nonIntegratedDevices[0]?.StatusCount || 0));
                    setLoading(false);

                } else {
                    setLoading(false);
                }

            })
        }catch(error){
            console.error(error)
        }
    }
    // To Get Dashboard Details 
    const GetUserDashboardDetails = async () => {
        let tempUser = JSON.parse(localStorage.getItem('user'))
        setDashboardLoading(true);
        try {
            let d0,d;
            let loggedInUser = JSON.parse(localStorage.getItem('user'))
            let offSetMinutes = loggedInUser?.OffsetMinutes;
            if(MULTI_TIME_ZONE){
                d = multiTimeZoneHelper(offSetMinutes);
                d0 = multiTimeZoneHelper(offSetMinutes);
                d0.setHours(0);
                d0.setMinutes(0);
                d0.setSeconds(0);
                d0 = new Date(d0);                
            }else{
                d = new Date();
                d0 = new Date();
                d0.setHours(0);
                d0.setMinutes(0);
                d0.setSeconds(0);
                d0 = new Date(d0);
            }
            let obj = {
                "action": "dashboardDetails",
                "userId": tempUser?.UserID,
                "todaysdate": ConvertDate(d),
                "todaysdatefrom": ConvertDate(d0)
            }

            GetDashboardDetails(obj).then((resp) => {
                if (resp.status == "Ok") {
                    // let refreshDate = subMinutes(now_utc, MSTdifference)
                    let refreshDate;
                    if(MULTI_TIME_ZONE){
                        let loggedInUser = JSON.parse(localStorage.getItem('user'))
                        let offSetMinutes = loggedInUser?.OffsetMinutes;
                        refreshDate = multiTimeZoneHelper(offSetMinutes)
                    }else{
                        refreshDate = new Date();
                    }
                    // let refreshDate = new Date();
                    setReseDashRefresh(AllDateFormat(refreshDate))
                    setDashboardData(resp.message)
                    setDashboardLoading(false);
                }
            })
        } catch (error) {
            console.error(error)
            setDashboardLoading(false);
        }
    }

    //get alert template/event template list
    const getEventTemplatesList = () => {
        GetEventTemplateList().then((resp) => {
            if (resp && resp.length > 0) {
                setEventTemplates(resp)
            }
        })
    }

    //Delete alert template/event template
    const onDeleteTemplate = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you really want to delete this template?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                DeleteEventTemplate(id).then((resp) => {
                    if (resp.status == "Ok") {
                        getEventTemplatesList()
                        Swal.fire(
                            'Deleted!',
                            "Alert template deleted successfully.",
                            'success'
                        )
                    }
                    else {
                        Swal.fire(
                            'Erroe!',
                            resp.message,
                            'failed'
                        )
                    }
                })

            }
        })
    }

    const fetchMoreData = () => {
        try {
            let startindex = 50
            if (parseInt(todaysAlertList.length) >= parseInt(props.alertcounts['TodaysAlerts'])) { return }
            // SortingList(todaysAlertList, startindex)
        } catch (error) {
            console.error(error)
        }
    }

    const SortingList = async (templist, index) => {
        try {
            let currentindex = index
            if (templist.length < currentindex) {
                currentindex = templist.length - 1
            } else {
                currentindex = templist.length
            }
            let dt;
            if(MULTI_TIME_ZONE){
                let loggedInUser = JSON.parse(localStorage.getItem('user'))
                let offSetMinutes = loggedInUser?.OffsetMinutes;
                dt = multiTimeZoneHelper(offSetMinutes)
              }else{
                // setCurrentDT(new Date());
                dt = new Date();
              }
            let obj = {
                "action": "getTodaysAlertsList",
                "userUniqueId": loggedInUser?.UserUniqueID || loggedInUser.userUniqueID,
                "startIndex": currentindex,
                "numberOfElements": index,
                "authCode": localStorage.getItem('authCode'),
                "currentDate": dt.toJSON().slice(0, 10)
            }

            await getAlertList(obj).then((resp) => {
                if (resp.status == "Ok") {
                    if (resp.message) {
                        let newList = (todaysAlertList.concat(resp.message))
                        setTodaysAlertList(newList)
                    }
                }
            })
        } catch (error) {
            console.error(error)
        }
    }
    const SystemHealthDevicesCount = () => {
        setLoading(true);
        let tempUser = JSON.parse(localStorage.getItem('user'));
        let userUniqueID = tempUser.UserUniqueID
        try {
            SystemHealthDevicesCountDash(userUniqueID).then((resp) => {
                if (resp != undefined) {
                    if (resp.message == "Unauthorized") {
                        LogoutDotNet().then((res) => {
                            logOutMain()
                            // localStorage.removeItem('authToken');
                            // localStorage.removeItem('authCode');
                            // localStorage.removeItem('user');
                            // localStorage.removeItem('userPassword');
                            // localStorage.removeItem('userID');
                            // localStorage.removeItem('hootWayData');
                            // localStorage.removeItem('sessionExpired');
                            // localStorage.removeItem('UserID');
                            // sessionStorage.removeItem('Page_Refresh_State');
                            // localStorage.removeItem('PlaySound');
                            history.push('/login');
                        })
                        return;
                    }
                    if (resp.Status == "success") {
                        let totalSystemHealthOffline = resp.Data.filter(item => item.Description == "System Health" && item.Status == "0")
                        setSystemHealthDevicesOfflineCount(totalSystemHealthOffline[0]?.Count || 0)
                        let offlineCount = totalSystemHealthOffline[0]?.Count || 0;
                        let totalSystemHealthOnline = resp.Data.filter(item => item.Description == "System Health" && item.Status == "1")
                        setSystemHealthDevicesOnlineCount(totalSystemHealthOnline[0]?.Count || 0)
                        let onlineCount = totalSystemHealthOnline[0]?.Count || 0
                        let total = parseInt(onlineCount) + parseInt(offlineCount)
                        let percent = (onlineCount / total) * 100;
                        if (isNaN(percent)) {
                            setOnlinePercent(0);
                        } else {
                            setOnlinePercent(percent.toFixed(0));
                        }

                        let nonIntegratedDevices = resp.Data.filter(item => item.Description == "System Health" && item.Status == "-1");
                        setNonIntegratedDevicesCount((nonIntegratedDevices[0]?.Count || 0));
                        setLoading(false);

                    } else {
                        setLoading(false);
                    }
                }
            })
        } catch (error) {
            console.error(error)

        }
    }

    //#endregion function region End

    /* Chart data start here */
    const data = {
        labels: ['Online', 'Offline'],
        datasets: [
            {
                label: 'Values',
                data: [systemHealthDevicesOnlineCount, systemHealthDevicesOfflineCount],
                borderRadius: 0,
                backgroundColor: ['#1ab243', '#dddddd'],
                borderWidth: 0,
                //hoverOffset: 4
            }
        ],

    }
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false
            }
        },
        cutout: "85%",

    }
    const plugins = [
        {
            beforeDraw: function (chart) {
                let width = chart.width,
                    height = chart.height,
                    ctx = chart.ctx;
                ctx.restore();
                ctx.font = "bolder 25px sans-serif";
                ctx.textBaseline = "middle";
                let text = `${onlinePercent}%`,
                    textX = Math.round((width - ctx.measureText(text).width) / 2),
                    textY = height / 2;
                ctx.fillStyle = darkPieGraph ? '' : '#BABABA';
                ctx.fillText(text, textX, textY);
                ctx.save();
            },
        },

    ]

    // console.log("todaysAlertList", todaysAlertList)
    /* Chart data end here */


    return (
        <div className='MainContentMargin'>
            <div className="row col-lg-12" style={{ margin: "0 auto", padding: "0px" }}>
                <div className="col-lg-12 pr-0 dashboardHeadingInnerDiv">
                    <div className="dashboardheadingMain">
                        <div className="dashboardheading" style={{ width: "100%" }}>
                            <p style={{ float: "left" }}>Welcome to MonitoringHub <span>{loggedInUser && " " + (loggedInUser.FullName)}</span></p>
                            <div className='RefreshText' style={{ float: "right" }}>
                                <h4 style={{ marginTop: "4px" }}>Refreshed on - {resetDashRefresh}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='dashboardScroll'>
                <div style={{display:"flex", flexWrap:"wrap", gap:"20px", margin:"10px", flex:"0 1 auto"}}>
                        <div className="systemHealth"
                        style={{
                            cursor: 'pointer', flex:"1", margin:"0",
                            display: IS_HEALTH_MONITORING_TAB_HIDDEN ? 'none' : 'block'
                            }} onClick={(e) => { history.push('/healthmonitoring') }}>
                            <div className='p-2'>
                            <div style={{float:"left", width:"100%",display:"flex", justifyContent:"space-between"}}>
                                <div>
                                    <div className="CardBoxImage" style={{ backgroundColor: "#1e93c2", width: "40px", height: "40px" }}>
                                    <img src={SystemHealth} alt="System health" style={{height: "21px"}} />
                                    </div>
                                    <h4 className="SystemHealthCardText">System Health</h4>
                                </div>
                                <div className="d-flex  align-items-center">
                                <p className="statusValueText mr-2">Total Devices: </p>
                                <p className="statusValueP">{(parseInt(systemHealthDevicesOfflineCount)) + (parseInt(systemHealthDevicesOnlineCount)) + (parseInt(nonIntegratedDevicesCount))}</p>
                                </div>
                            </div>
                            <div className="chartsStatusDiv">
                            
                            <div style={{ display: "flex", width: "51%", marginTop: "20px", height:"150px" }}>
                                <HealthIntegratedChart isDarkTheme={props.isDarkTheme} systemHealthDevicesOfflineCount={systemHealthDevicesOfflineCount} systemHealthDevicesOnlineCount={systemHealthDevicesOnlineCount} nonIntegratedDevicesCount={nonIntegratedDevicesCount} />
                            </div>
                            <div style={{ height: "130px", display: "flex",justifyContent:"center",flexDirection:"column", alignItems:"flex-end", marginRight: "20px",marginBottom:"15px"}}>
                                <HealthPercent systemHealthDevicesOnlineCount={systemHealthDevicesOnlineCount} systemHealthDevicesOfflineCount={systemHealthDevicesOfflineCount} onlinePercent={onlinePercent} isDarkTheme={props.isDarkTheme} count={count} />
                            </div>                            
                            </div>
                            </div>
                        </div>
                        
                        <div style={{flex:"1"}}
                            className='DashboardKpi'>
                            {/* <DashboardWidget dashboardLoading={props.rootLoading} count={props?.alertcounts['TodaysAlerts'] || 0} type="Today's Alerts" pointer={IS_ALERTS_TAB_HIDDEN} bgColor="#DA8012" imgIcon={AlertWhiteIcon} redirectTo="/allalerts" /> */}
                            <DashboardWidget dashboardLoading={todayAlertLoading} count={todaysAlertCount || 0} type="Today's Alerts"  pointer={IS_ALERTS_TAB_HIDDEN ? 'none' : 'auto'} bgColor="#DA8012" imgIcon={AlertWhiteIcon} redirectTo={IS_ALERTS_TAB_HIDDEN ? null : ALLALERTS} />
                            {/* <DashboardMiniWidget text={dashboardData && dashboardData.alertsMostlyGenerated != null && dashboardData.alertsMostlyGenerated + " Severity"} label="Alerts mostly generated" icon={ErrorIcon}  pointer={IS_ALERTS_TAB_HIDDEN ? 'none' : 'auto'}/> */}
                            <DashboardMiniWidget text={maxSeverityTitle ? `${maxSeverityTitle} Severity` : "--"} label="Alerts mostly generated" icon={ErrorIcon} pointer={IS_ALERTS_TAB_HIDDEN ? "none" : "auto"}/>
                        </div>

                        <div style={{flex:"1"}}
                            className='DashboardKpi'>
                           {/*  <DashboardWidget dashboardLoading={siteLoading} count={siteCount} type="Sites" pointer={IS_SITE_MANAGEMENT_TAB_HIDDEN} bgColor="#6459D6" imgIcon={SiteWhiteIcon} redirectTo="/configuration?initialTemplate=0" /> */}
                            <DashboardWidget dashboardLoading={siteLoading} count={siteCount} type="Sites" pointer={IS_SITE_MANAGEMENT_TAB_HIDDEN ? 'none' : 'auto'} bgColor="#6459D6" imgIcon={SiteWhiteIcon} redirectTo={IS_CONFIGURATION_TAB_HIDDEN ? null : "/configuration?initialTemplate=0"} />
                            <DashboardMiniWidget text={workflowDash ? workflowDash : "--"} label="Most used workflow template" icon={WFIcon} pointer={IS_ALERTS_TAB_HIDDEN ? 'none' : 'auto'}/>
                        </div>

                        <div style={{flex:"1"}}
                            className='DashboardKpi'>
                            <DashboardWidget dashboardLoading={deviceLoading} count={deviceCount} type="Cameras" bgColor="#27AD93" imgIcon={CameraWhiteIcon} redirectTo={ IS_CAMERAS_TAB_HIDDEN ? null : 'cameras/true'} pointer={IS_CAMERAS_TAB_HIDDEN ? 'none' : 'auto'}  />
                            <DashboardMiniWidget text={closedAlertCount} label="Today's closed alerts" icon={ClosedAlertIcon} pointer={IS_ALERTS_TAB_HIDDEN ? 'none' : 'auto'}/>
                        </div>
                </div>

                {/* <div className="RowClass"> */}

                    <div className='DashboardAlertTable'>
                        <div className="alertTable" style={{flex:"3", display:"flex", flexDirection:'column'}}>
                            <div className="alertTableList" style={{flex:"0 1 auto"}}>
                                {/* <p>Today's Alert(s)</p> */}
                                {
                                    !IS_ALERTS_TAB_HIDDEN && <p className='TextValue'>Today's Alert(s)</p>
                                }
                                {
                                !IS_ALERTS_TAB_HIDDEN && alert && props && props.alertcounts && props.alertcounts['TodaysAlerts'] !== undefined  //TodaysOpenAlert
                                && (
                                    <button className="viewAllListBtn" onClick={() => history.push('/allalerts')}><p>View All Open Alerts</p></button>
                                )}
                            </div>
                            {
                                IS_ALERTS_TAB_HIDDEN ?
                                <div 
                                style={{
                                    display: 'flex',
                                    float: 'left',
                                    height: '488px',
                                    alignItems: 'center',
                                    fontSize: '20px',
                                    fontWeight: '700',
                                    justifyContent:"center",
                                    position:'relative',
                                }}>
                                    <p className='RestrictedText'>Restricted Access</p>
                                </div>
                                :
                                <table className="table sticky-table text-center removeClickStyle mb-0" style={{flex:"1 1 auto", display:"flex", flexDirection:"column"}}>
                                <thead style={{flex:"0 0 auto"}}>
                                    <tr>
                                        <td>ID</td>
                                        <td>Customer</td>
                                        <td>Site</td>
                                        <td>Device</td>
                                        <td>ACK By</td>
                                        <td>Owner</td>
                                        <td>Timezone</td>
                                        <td>ACK On</td>
                                        <td>Closed On</td>
                                        <td>Status</td>
                                        <td>Severity</td>
                                        <td>Type</td>
                                    </tr>
                                </thead>
                                <tbody className="tbody-dashboard" style={{flex:"1 1 auto"}}>
                                    {
                                        //!todaysAlertList || todaysAlertList?.length === 0
                                        props.rootLoading
                                            ?
                                            (
                                                <tr>
                                                    {
                                                        <>
                                                            <td>
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                            <td>
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                            <td>
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                            <td>
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                            <td className="online-color">
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                            <td>
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                            <td>
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                            <td>
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                            <td>
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                            <td>
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                            <td>
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                            <td>
                                                                <Skeleton className="width70pct" />
                                                            </td>
                                                        </>
                                                    }
                                                </tr>
                                            )
                                            :
                                            (
                                                <>
                                                    <div id="scrollableDiv">
                                                        <InfiniteScroll
                                                            dataLength={todaysAlertList && todaysAlertList.length}
                                                            next={fetchMoreData}
                                                            hasMore={true}
                                                            scrollableTarget="scrollableDiv"
                                                        >
                                                            {
                                                                (todaysAlertList && todaysAlertList.length > 0)
                                                                    ?
                                                                    todaysAlertList
                                                                    // .filter(x => x.actualTime.split(' ')[0] == ConvertDate(new Date()).split(' ')[0])
                                                                    .map((item, index) =>
                                                                        <AlertTable
                                                                            key={item.AlertId}
                                                                            id={item.AlertId}
                                                                            props={item}
                                                                            onAddAlertChat={props.onAddAlertChat}
                                                                        />
                                                                    )
                                                                    : <div className='noRecordFound'><p className='noRecordFoundText'>No Record Found</p></div>
                                                            }
                                                        </InfiniteScroll>
                                                    </div>
                                                    {
                                                        (!todaysAlertList || todaysAlertList.length === 0) && (
                                                            <div className='noRecordFound'><p className='noRecordFoundText'>No Record Available</p></div>
                                                        )
                                                    }
                                                </>
                                            )

                                    }
                                </tbody>
                                </table>
                            }
                        </div>

                        <div style={{flex:"1", display:"none", flexDirection:"column"}}>
                                <div className="kpi-card topLocations-widget">
                                    <div className="section-head">
                                        <span className="location-alerts">Location Generated Alerts</span>
                                    </div>
                                    <div>
                                        <ul className="nav nav-pills tabs-list">
                                            <li className="nav-item">
                                                <div className={selectedSiteTab == "topThreeSites" ? "nav-link active top-three-sites" : "inactive-text-dashboard top-three-sites"}
                                                    onClick={() => setSelectedSiteTab('topThreeSites')}>
                                                    Top 3 sites</div>
                                            </li>
                                            <li className="nav-item">
                                                <div className={selectedSiteTab == "bottomThreeSites" ? "nav-link active bottom-three-sites" : "inactive-text-dashboard bottom-three-sites"}
                                                    onClick={() => setSelectedSiteTab('bottomThreeSites')}>
                                                    Bottom 3 sites</div>
                                            </li>
                                        </ul>
                                    </div>
                                    <>
                                        {selectedSiteTab && selectedSiteTab == "topThreeSites" &&
                                            (<div className="tab-pane container active template-list pl-0 pr-0" id="top-3">
                                                {(dashboardData &&
                                                    dashboardData.topThreeAlertsGeneratedSites && dashboardData.topThreeAlertsGeneratedSites.length > 0 ?
                                                    dashboardData.topThreeAlertsGeneratedSites.map((item, index) =>
                                                        <LocationList key={item.siteId}
                                                            id={item.siteId}
                                                            sites={item} />
                                                    ) : (
                                                        <div className='noRecordFound'><p className='noRecordFoundText' style={{ left: "35%" }}>No Record Available</p></div>
                                                    )
                                                )}
                                            </div>)
                                        }
                                        {selectedSiteTab && selectedSiteTab == "bottomThreeSites" &&
                                            (<div className="tab-pane container active template-list pl-0 pr-0" id="bottom-3">
                                                {(dashboardData &&
                                                    dashboardData.bottomThreeAlertsGeneratedSites && dashboardData.bottomThreeAlertsGeneratedSites.length > 0 ?
                                                    dashboardData.bottomThreeAlertsGeneratedSites.map((item, index) =>
                                                        <LocationList key={item.siteId}
                                                            id={item.siteId}
                                                            sites={item} />
                                                    ) : (
                                                        <div className='noRecordFound'><p className='noRecordFoundText' style={{ left: "35%" }}>No Record Available</p></div>
                                                    )
                                                )}
                                            </div>)
                                        }
                                    </>
                                </div>
                                <div className='mt-3'>
                                    {
                                        isSuperUser &&
                                            <div className="kpi-card quick-config-widget">
                                                <div className="section-head quick">
                                                    <span className="location-alerts quick-config-widget">Quick Configurations</span>
                                                </div>
                                                <div className='dashboard-quickconfig-alerttemplate-outer'>
                                                    <div className='dashboard-quickconfig-alerttemplate-inner'>
                                                        <p className='dashboard-quickconfig-alerttemplate-text'>Alert Template</p>
                                                    </div>
                                                </div>

                                                <>
                                                    <div className="tab-pane container active pl-0 pr-0 template-list mt-1 QuickConfigHeight" id="alerts">

                                                        {(
                                                            eventTemplates &&
                                                            eventTemplates?.map((item, index) =>
                                                                <EventTemplateList
                                                                    key={item.AlertTemplateId}
                                                                    id={item.AlertTemplateId}
                                                                    template={item}
                                                                    onDeleteTemplate={onDeleteTemplate}
                                                                    history={history} />
                                                            )
                                                        )}
                                                        {
                                                            !eventTemplates &&
                                                            <div className='noRecordFound'><p className='noRecordFoundText' style={{ left: "35%" }}>No Record Available</p></div>
                                                        }
                                                    </div>
                                                </>
                                            </div>
                                    }
                                </div>
                        </div>
                    </div>
                {/* </div> */}
            </div>
        </div>
    )
}